import type { RecursiveRequired, Settings } from '#/global'
import { cloneDeep } from 'es-toolkit'
import settingsDefault from '@/settings.default'
import { merge } from '@/utils/object'

const globalSettings: Settings.all = {
  app: {
    lightTheme: 'blue',
    darkTheme: 'blue',
    enablePermission: true,
  },
  menu: {
    mode: 'single',
  },
  toolbar: {
    navSearch: false,
  },
  mainPage: {
    enableHotkeys: false,
  },
  navSearch: {
    enableHotkeys: false,
  },
  layout: {
    enableMobileAdaptation: true,
  },
  tabbar: {
    enable: true,
    style: 'fashion',
  },
  copyright: {
    enable: true,
    dates: '2025',
    company: '云奕智（深圳）信息科技有限公司',
    beian: ' 粤ICP备2025407320号-1',
    customer: ' 模板货运代理有限公司',
  },
}

export default merge(globalSettings, cloneDeep(settingsDefault)) as RecursiveRequired<Settings.all>
